/*
 * Workaround for Product Personalizer (Zepto Apps) leaving products with a
 * hidden underlying <img> behind an empty canvas. When the canvas is empty,
 * reveal the original product image so users see something.
 *
 * Remove this once Zepto Apps fixes the empty-canvas behavior upstream.
 */
(function () {
  var FALLBACK_DELAY_MS = 2500;

  function canvasIsEmpty(canvas) {
    try {
      var ctx = canvas.getContext('2d');
      var w = Math.min(canvas.width, 200);
      var h = Math.min(canvas.height, 200);
      var data = ctx.getImageData(0, 0, w, h).data;
      for (var i = 3; i < data.length; i += 4) {
        if (data[i] !== 0) return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function revealStuckImages() {
    var wrappers = document.querySelectorAll('.pplr');
    for (var i = 0; i < wrappers.length; i++) {
      var wrap = wrappers[i];
      var img = wrap.querySelector(':scope > img:not(.zoomImg)');
      if (!img) continue;
      var preview = wrap.querySelector('.pplr_preview_wrapper');
      var canvas = preview ? preview.querySelector('canvas') : null;
      if (canvas && !canvasIsEmpty(canvas)) continue;
      img.style.visibility = 'visible';
      if (preview) preview.style.display = 'none';
    }
  }

  function schedule() {
    setTimeout(revealStuckImages, FALLBACK_DELAY_MS);
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule);
  }
})();
